import { baseApi } from 'core/api';

const state = () => ({});

const getters = {};

const actions = {
    getExtensionContact({ contactIntegrationId, externalSource }) {
        return baseApi
            .get('core/extension/contact', {
                params: {
                    contact_integration_id: contactIntegrationId,
                    external_source: externalSource,
                },
            })
            .then((response) => {
                return response.data;
            });
    },
    getHubspotExtensionContact(contactIntegrationId) {
        return baseApi
            .get('core/hubspot/extension/contact', {
                params: { contact_integration_id: contactIntegrationId },
            })
            .then((response) => {
                return response.data;
            });
    },

    createHubspotExtensionContact({ data = {}, form }) {
        if (form) {
            return form.post('core/hubspot/extension/contact').then((response) => {
                return response.data;
            });
        } else {
            return baseApi.post('core/hubspot/extension/contact', data).then((response) => {
                return response.data;
            });
        }
    },

    createExtensionContact({ data = {}, form, externalSource }) {
        if (form) {
            return form
                .post(`core/extension/contact?external_source=${externalSource}`)
                .then((response) => {
                    return response.data;
                });
        } else {
            return baseApi
                .post(`core/extension/contact?external_source=${externalSource}`, data)
                .then((response) => {
                    return response.data;
                });
        }
    },

    // deprecated Use instead - updateExtensionContactByIdLink
    updateHubspotExtensionContactByIdLink({ form, contactId }) {
        return form.post(`core/hubspot/extension/contact/${contactId}/link`).then((response) => {
            return response.data;
        });
    },

    updateExtensionContactByIdLink({ form, contactId, source }) {
        return form
            .post(`core/extension/contact/${contactId}/link`, {
                external_source: source,
                contact_integration_id: form.contact_integration_id,
            })
            .then((response) => {
                return response.data;
            });
    },

    getHubspotExtensionUserDetect(data) {
        return baseApi
            .get('core/hubspot/extension/user/detect', {
                params: data,
            })
            .then((response) => {
                return response.data;
            });
    },

    createHubspotExtensionUserInvitationRequest(data) {
        return baseApi
            .post('core/hubspot/extension/user/invitation/request', data)
            .then((response) => {
                return response.data;
            });
    },

    updateHubspotExtensionConversation(data) {
        return baseApi.post('core/hubspot/extension/conversation', data).then((response) => {
            return response.data;
        });
    },

    getHubspotExtensionHubspotContactSearch(config) {
        return baseApi
            .get('core/hubspot/extension/hubspot/contact/search', config)
            .then((response) => {
                return response.data;
            });
    },

    getExtensionIntegrationContactSearch(config) {
        return baseApi.get('core/extension/integration/contact/search', config).then((response) => {
            return response.data;
        });
    },

    getHubspotExtensionContactSearchById(contactId) {
        return baseApi
            .get(`core/hubspot/extension/contact/search/${contactId}`)
            .then((response) => {
                return response.data;
            });
    },

    getHubspotContactByIdInfo(contactId) {
        return baseApi.get(`core/hubspot/contact/${contactId}/info`).then((response) => {
            return response.data.data;
        });
    },

    getPipedriveExtensionContactSearchById(contactId) {
        return baseApi
            .get('core/pipedrive/extension/contact', {
                params: { contact_integration_id: contactId },
            })
            .then((response) => {
                return response.data;
            });
    },
};



export default {
    state,
    getters,
    actions,
};
